import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';

import {
  CurrencyComponent,
  getColumnKey,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import {
  OrderStatusComponent,
  PublicOrderCollectionFilter,
  PublicOrderCollectionItem,
  RefundedPriceComponent,
} from '@web/shared/module/shop';
import { isNil, isNotNil } from '@web/utils';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-public-order-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    OrderStatusComponent,
    RouterLinkComponent,
    Tooltip,
    RefundedPriceComponent,
    CurrencyComponent,
  ],
  templateUrl: './public-order-list-custom-cell-template.component.html',
  styleUrl: './public-order-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicOrderListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<PublicOrderCollectionItem, PublicOrderCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<PublicOrderCollectionItem>();

  protected readonly detailsParams = this.detailsParamsSignal();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<PublicOrderCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly Route = Route;

  private detailsParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => ({
      [RouteParam.Number]: this.model().number,
    }));
  }

  protected readonly isNil = isNil;
}
